import UnautheneticatedLayout from '@/vue-app/layouts/UnauthenticatedLayout.vue';
import Login from '@/vue-app/views/Login.vue';
import POLICIES from '../security/policies';

export default {
  path: '/login',
  component: UnautheneticatedLayout,
  children: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        access_policy: POLICIES.UNAUTHENTICATED,
      },
    },
  ],
};
